<script lang="ts">
import type { VNode } from "vue";

import type { UtteranceToRender } from "./VoiceTranscriptUtterances.vue";

export type Slots = { beforeUtterance(props: { index: number }): VNode[] };
</script>
<script setup lang="ts">
import { ref } from "vue";

defineSlots<Slots>();
const props = defineProps<{ index: number; utterance: UtteranceToRender; class?: string }>();

const element = ref<HTMLElement>();

defineExpose({ element });
</script>
<template>
  <div ref="element" :="$attrs" class="tw-flex tw-divide-x">
    <slot name="beforeUtterance" :index="index" />
    <div
      class="tw-grow"
      :class="[
        utterance.isContext ? 'tw-font-light' : 'tw-font-medium',
        utterance.isSpeakerStart && 'tw-space-y-[2px]',
        props.class,
      ]"
    >
      <div
        v-if="utterance.isSpeakerStart"
        data-type="speaker"
        class="tw-text-dark-green tw-flex tw-select-none tw-items-center tw-gap-2 tw-pl-4 tw-pt-1 tw-text-xs tw-font-bold"
      >
        {{ utterance.speakerName }}
      </div>
      <p data-type="utterance" class="tw-break-words tw-pl-8 tw-text-black" v-html="utterance.dialogueText" />
    </div>
  </div>
</template>
